import { PHONE_NUMBER_REGEX } from "@constants";
import { i18n, Translations } from "@i18n";
import * as yup from "yup";
import { ShareGoalContactRouteFormValues } from "./types";

export const validationSchema: yup.SchemaOf<ShareGoalContactRouteFormValues> = yup.object().shape({
  phoneNumber: yup
    .string()
    .required(i18n.t(Translations.ShareGoalContactRouteInputRequired))
    .matches(PHONE_NUMBER_REGEX, i18n.t(Translations.ShareGoalContactRouteInputInvalid)),
});
